import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-welcome-modal',
    templateUrl: './welcome-modal.component.html',
    styleUrls: ['./welcome-modal.component.scss'],
    standalone: false
})
export class WelcomeModalComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<WelcomeModalComponent>, private readonly cookieService: CookieService) {}

  ngOnInit(): void {
    this.dialogRef.addPanelClass('cdk-panel-custom');

    this.dialogRef.afterClosed().subscribe(() => {
      this.setHasSeenModalCookie();
    });
  }

  setHasSeenModalCookie() {
    const date365IntoFuture = new Date();
    date365IntoFuture.setDate(date365IntoFuture.getDate() + 365);

    this.cookieService.set(
      'has_seen_hub_welcome_modal',
      `true`,
      date365IntoFuture,
      '/',
      environment.mainDomain,
      environment.production,
      'Strict'
    );
  }
}
